import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./styles.module.css";

const FilterBox = ({ isTypeView, children }) => {
  const wrapperClasses = classNames({
    [styles.wrapper]: true,
    [styles.isTypeView]: isTypeView,
  });

  return <div className={wrapperClasses}>{children}</div>;
};

FilterBox.propTypes = {
  isTypeView: PropTypes.bool,
  children: PropTypes.any,
};

export default FilterBox;
